import { render } from "./TramiteCarga.vue?vue&type=template&id=1470fa52&scoped=true"
import script from "./TramiteCarga.vue?vue&type=script&lang=js"
export * from "./TramiteCarga.vue?vue&type=script&lang=js"

import "./TramiteCarga.vue?vue&type=style&index=0&id=1470fa52&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1470fa52"]])

export default __exports__